export default __webpack_public_path__ + "static/media/FourPartIllustration.af410c29.png";